var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarioBuscar2020X240(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 240,
    viewBox: "0 0 220 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "imagen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M165.93 90.5299C164.41 90.5299 163.11 89.3799 162.95 87.8399C162.78 86.1899 163.98 84.7199 165.63 84.5499C166.22 84.4899 166.8 84.4099 167.38 84.3199C169.02 84.0599 170.56 85.1599 170.82 86.7999C171.09 88.4299 169.98 89.9799 168.34 90.2399C167.65 90.3499 166.94 90.4499 166.24 90.5199C166.14 90.5299 166.03 90.5399 165.93 90.5399V90.5299ZM154.36 89.6599C154.11 89.6599 153.86 89.6299 153.61 89.5599C152.92 89.3799 152.24 89.1799 151.57 88.9599C149.99 88.4499 149.13 86.7499 149.65 85.1799C150.16 83.5999 151.85 82.7399 153.43 83.2599C153.99 83.4399 154.55 83.6099 155.12 83.7499C156.72 84.1699 157.69 85.7999 157.27 87.4099C156.92 88.7599 155.7 89.6599 154.37 89.6599H154.36ZM178.79 86.3699C177.75 86.3699 176.74 85.8299 176.19 84.8699C175.36 83.4299 175.86 81.5999 177.29 80.7699C177.8 80.4799 178.3 80.1699 178.79 79.8399C180.17 78.9299 182.03 79.3099 182.95 80.6899C183.86 82.0699 183.48 83.9299 182.1 84.8499C181.51 85.2399 180.91 85.6099 180.29 85.9699C179.82 86.2399 179.3 86.3699 178.79 86.3699ZM142.28 83.5999C141.62 83.5999 140.96 83.3899 140.41 82.9499C139.86 82.5099 139.32 82.0499 138.79 81.5699C137.56 80.4599 137.46 78.5599 138.57 77.3299C139.68 76.0999 141.58 75.9999 142.81 77.1099C143.25 77.4999 143.69 77.8799 144.15 78.2499C145.45 79.2799 145.66 81.1699 144.62 82.4699C144.03 83.2099 143.15 83.5999 142.27 83.5999H142.28ZM188.84 77.3399C188.23 77.3399 187.61 77.1499 187.07 76.7599C185.73 75.7799 185.44 73.9099 186.42 72.5699C186.77 72.0999 187.1 71.6099 187.42 71.1099C188.32 69.7199 190.17 69.3199 191.57 70.2099C192.96 71.1099 193.37 72.9599 192.47 74.3599C192.09 74.9599 191.69 75.5399 191.27 76.1099C190.68 76.9099 189.77 77.3399 188.84 77.3399ZM133.7 73.1699C132.62 73.1699 131.57 72.5799 131.04 71.5499C130.71 70.9199 130.4 70.2799 130.12 69.6299C129.45 68.1199 130.12 66.3399 131.64 65.6699C133.15 64.9999 134.93 65.6699 135.6 67.1899C135.84 67.7299 136.1 68.2599 136.37 68.7799C137.14 70.2499 136.56 72.0599 135.09 72.8299C134.65 73.0599 134.17 73.1699 133.71 73.1699H133.7ZM194.36 65.0099C194.15 65.0099 193.94 64.9899 193.73 64.9399C192.11 64.5899 191.08 62.9999 191.42 61.3799C191.54 60.8099 191.65 60.2299 191.74 59.6399C191.99 57.9999 193.53 56.8799 195.16 57.1199C196.8 57.3699 197.92 58.8999 197.68 60.5399C197.57 61.2399 197.45 61.9399 197.3 62.6299C197 64.0399 195.75 64.9999 194.37 64.9999L194.36 65.0099ZM130.1 60.1299C128.52 60.1299 127.2 58.8999 127.11 57.3099C127.07 56.6099 127.05 55.8999 127.05 55.1899V55.0599C127.05 53.3999 128.39 52.0599 130.05 52.0599C131.71 52.0599 133.05 53.3999 133.05 55.0599V55.1899C133.05 55.7799 133.07 56.3699 133.1 56.9499C133.2 58.5999 131.94 60.0199 130.28 60.1199C130.22 60.1199 130.16 60.1199 130.1 60.1199V60.1299ZM194.38 51.4899C192.99 51.4899 191.74 50.5199 191.45 49.1099C191.33 48.5299 191.19 47.9599 191.04 47.3899C190.61 45.7899 191.55 44.1399 193.15 43.7099C194.75 43.2799 196.4 44.2199 196.83 45.8199C197.01 46.4999 197.18 47.1799 197.33 47.8799C197.67 49.4999 196.63 51.0899 195.01 51.4299C194.8 51.4699 194.59 51.4999 194.39 51.4999L194.38 51.4899ZM132.16 46.6399C131.81 46.6399 131.45 46.5799 131.09 46.4399C129.54 45.8499 128.76 44.1199 129.35 42.5699C129.6 41.9099 129.87 41.2499 130.16 40.6099C130.84 39.0999 132.62 38.4199 134.13 39.1099C135.64 39.7899 136.31 41.5699 135.63 43.0799C135.39 43.6099 135.16 44.1599 134.96 44.7099C134.5 45.9099 133.36 46.6499 132.16 46.6499V46.6399ZM188.92 39.1299C187.99 39.1299 187.08 38.6999 186.49 37.8899C186.14 37.4099 185.78 36.9399 185.41 36.4899C184.36 35.2099 184.55 33.3199 185.83 32.2699C187.11 31.2199 189 31.4099 190.05 32.6899C190.5 33.2399 190.93 33.7999 191.34 34.3699C192.31 35.7099 192.01 37.5899 190.67 38.5599C190.14 38.9499 189.52 39.1299 188.91 39.1299H188.92ZM139.48 35.2899C138.72 35.2899 137.95 34.9999 137.37 34.4199C136.19 33.2499 136.19 31.3499 137.35 30.1799C137.85 29.6799 138.36 29.1899 138.89 28.7199C140.12 27.6199 142.02 27.7199 143.13 28.9499C144.24 30.1799 144.13 32.0799 142.9 33.1899C142.46 33.5799 142.03 33.9899 141.62 34.4099C141.03 34.9999 140.26 35.2999 139.49 35.2999L139.48 35.2899ZM178.89 30.0599C178.38 30.0599 177.86 29.9299 177.38 29.6499C176.87 29.3599 176.36 29.0699 175.83 28.8099C174.35 28.0599 173.76 26.2599 174.5 24.7799C175.25 23.2999 177.05 22.7099 178.53 23.4499C179.16 23.7699 179.79 24.1099 180.4 24.4599C181.83 25.2899 182.32 27.1299 181.48 28.5599C180.92 29.5199 179.92 30.0499 178.88 30.0499L178.89 30.0599ZM150.78 27.8699C149.58 27.8699 148.44 27.1399 147.98 25.9499C147.38 24.4099 148.15 22.6699 149.69 22.0699C150.35 21.8099 151.02 21.5799 151.69 21.3599C153.27 20.8499 154.96 21.7199 155.46 23.2999C155.97 24.8799 155.1 26.5699 153.52 27.0699C152.96 27.2499 152.4 27.4499 151.85 27.6599C151.49 27.7999 151.13 27.8599 150.76 27.8599L150.78 27.8699ZM166.06 25.8499C165.95 25.8499 165.85 25.8499 165.74 25.8299C165.16 25.7699 164.57 25.7199 163.98 25.6999C162.32 25.6199 161.05 24.2199 161.12 22.5599C161.2 20.8999 162.62 19.6399 164.26 19.6999C164.97 19.7299 165.68 19.7899 166.38 19.8599C168.03 20.0399 169.22 21.5099 169.04 23.1599C168.88 24.6999 167.57 25.8399 166.06 25.8399V25.8499Z",
    fill: "#A7B1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M171.96 69.8199C171.08 69.8199 170.22 69.4399 169.62 68.6999L160.22 57.0599C159.79 56.5299 159.55 55.8599 159.55 55.1799V35.8699C159.55 34.2099 160.89 32.8699 162.55 32.8699C164.21 32.8699 165.55 34.2099 165.55 35.8699V54.1199L174.28 64.9299C175.32 66.2199 175.12 68.1099 173.83 69.1499C173.28 69.5999 172.61 69.8199 171.95 69.8199H171.96Z",
    fill: "#A7B1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M189.779 39.1698H178.939C177.279 39.1698 175.939 37.8298 175.939 36.1698C175.939 34.5098 177.279 33.1698 178.939 33.1698H186.779V25.3298C186.779 23.6698 188.119 22.3298 189.779 22.3298C191.439 22.3298 192.779 23.6698 192.779 25.3298V36.1698C192.779 37.8298 191.439 39.1698 189.779 39.1698Z",
    fill: "#A7B1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M155.12 89.8399C154.89 89.8399 154.66 89.8099 154.43 89.7599C138.31 85.9799 127.05 71.7599 127.05 55.1799C127.05 35.5999 142.98 19.6699 162.56 19.6699C173.57 19.6699 183.77 24.6499 190.56 33.3399C191.58 34.6499 191.35 36.5299 190.04 37.5499C188.73 38.5699 186.85 38.3399 185.83 37.0299C180.19 29.8099 171.71 25.6699 162.56 25.6699C146.29 25.6699 133.05 38.9099 133.05 55.1799C133.05 68.9599 142.41 80.7799 155.8 83.9199C157.41 84.2999 158.41 85.9099 158.04 87.5299C157.72 88.9099 156.48 89.8499 155.12 89.8499V89.8399Z",
    fill: "#A7B1BF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M96.4596 185.17H42.1396C32.1996 185.17 24.1396 177.11 24.1396 167.17V77.1899C24.1396 67.2499 32.1996 59.1899 42.1396 59.1899H117.98",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M164.56 99.9099V127.5",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.8496 95.2199H57.1296",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77.7598 95.2199H84.0398",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M104.67 95.2199H110.95",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M131.58 95.2199H137.86",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M50.8496 159.61H57.1296",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M77.7598 159.61H84.0398",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50.8496 116.68H57.1296",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M77.7598 116.68H84.0398",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M104.67 116.68H110.95",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M131.58 116.68H137.86",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M50.8496 138.14H57.1296",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M77.7598 138.14H84.0398",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M104.67 138.14H110.95",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M50.8496 70.4399V47.9199",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M94.3496 70.4399V47.9199",
    stroke: "#A7B1BF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M151.899 225.32C176.178 225.32 195.859 205.638 195.859 181.36C195.859 157.081 176.178 137.4 151.899 137.4C127.621 137.4 107.939 157.081 107.939 181.36C107.939 205.638 127.621 225.32 151.899 225.32Z",
    stroke: "#2FB699",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M131.909 182.14L144.719 194.95L171.879 167.78",
    stroke: "#2FB699",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioBuscar2020X240);
export default __webpack_public_path__ + "static/media/CALENDARIO_BUSCAR_2020X240.980256d7d1945dd58bef5416d3a0a513.svg";
export { ForwardRef as ReactComponent };